(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    class FooterMenu extends HTMLElement {
      constructor() {
        super();
        this.disclosure = this.querySelector('details');
        this.toggle = this.querySelector('summary');
        
        if (!this.disclosure || !this.toggle) return;
        
        // Set initial state based on screen size
        this.resetState();
        
        // Listen for resize events
        let resizeTimer;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            this.resetState();
          }, 250);
        });
      }

      resetState() {
        const isLargeScreen = window.matchMedia('(min-width: 769px)').matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        // Open on desktop, closed on mobile (unless newsletter confirmation)
        if (isLargeScreen) {
          this.disclosure.setAttribute('open', '');
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          if (!isConfirmNewsletter) {
            this.disclosure.removeAttribute('open');
          }
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    // Define the custom element
    if (!customElements.get('footer-menu')) {
      customElements.define('footer-menu', FooterMenu);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
